import axios from "axios";
import { GetIndicesResponseType, GetMarketIndicesResponseType, GetSectorIndicesResponseType } from "../types/indices.type";
import { Region } from "../utils/type";
import { apiBase } from './apiBase';
export const getMarketIndices = (region: Region, token: string): Promise<GetMarketIndicesResponseType> => {
    return new Promise(async (resolve, reject) => {
        axios
            .get(`${apiBase()}/marketindices/`, {
                params: { region: region, token: token },
            })
            .then((res) => {
                if (res.data.data) {
                    resolve(res.data.data);
                } else {
                    resolve(undefined as any);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const getSectorIndices = (region: string, token: string, sortcol?: string, sortord?: string): Promise<GetSectorIndicesResponseType> => {
    return new Promise(async (resolve, reject) => {
        const params: any = { region: region, token: token };
        if (sortcol) {
            params.sortcol = sortcol;
        }
        if (sortord) {
            params.sortord = sortord;
        }
        axios
            .get(`${apiBase()}/sectorindices/`, {
                params: params,
            })
            .then((res) => {
                if (res.data.data) {
                    resolve(res.data.data);
                } else {
                    resolve(undefined as any);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
};


export const getIndices = (region: string, token: string, sortcol?: string, sortord?: string): Promise<GetIndicesResponseType> => {
    return new Promise(async (resolve, reject) => {
        const params: any = { token: token };
        if (region) {
            params.region = region;
        }
        if (sortcol) {
            params.sortcol = sortcol;
        }
        if (sortord) {
            params.sortord = sortord;
        }
        axios
            .get(`${apiBase()}/indices/`, {
                params: params,
            })
            .then((res) => {
                if (res.data.data) {
                    resolve(res.data.data);
                } else {
                    resolve(undefined as any);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
};